import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";

export const PaymentCancel = () => (
  <div data-testid="payment-cancel-page">
    <PageHeader eyebrow="Checkout" title="Payment cancelled">No charge was made. Your cart is saved.</PageHeader>
    <div className="wb-container"><Link to="/cart" className="btn-gold" data-testid="cancel-back-to-cart">Return to cart</Link></div>
  </div>
);

export const NotFound = () => (
  <div data-testid="not-found-page">
    <PageHeader eyebrow="404" title="Lost in the mist">This page does not exist.</PageHeader>
    <div className="wb-container"><Link to="/" className="btn-gold">Go home</Link></div>
  </div>
);
